export default {
	landingPageHeader: {
		width: '90%',
		boxSizing: 'border-box',
		margin: '0 auto',
		padding: '25px 25px 10px 25px',
		display: 'flex',
		flexWrap: 'wrap'
	},
	landingPageText: {
		flex: '1',
		marginTop: '5px'
	},
	landingPageButtonContainer: {
		flex: '1',
		display: 'flex',
		alignItems: 'flex-start',
		flexWrap: 'wrap'
	},
	buttonContainer: {
		flex: '1',
		minWidth: '200px',
		margin: '0 5px 3px 5px'
	},
	tinyText: {
		textAlign: 'center',
		fontSize: '10px',
		marginTop: '5px'
	},
	descriptionContainer: {
		width: '90%',
		margin: '25px auto 0 auto',
		padding: '25px',
		whiteSpace: 'pre-wrap'
	},
	hideForm: {
		display: 'none'
	},
	formContainer: {
		width: '100%',
		maxWidth: '400px',
		margin: '25px auto 0 auto',
		padding: '25px 25px 40px 25px'
	},
	registerButton: {
		marginTop: '1.5em'
	},
	tos: {
		fontSize: '10px',
		textAlign: 'center',
		width: '100%',
		marginTop: '10px'
	},
	landingPageError: {
		padding: '10px'
	}
};



// WEBPACK FOOTER //
// ./src/main/webapp/media/scripts/webpack/invitationlandingpage/styles/index.js